// getContactName and getSigningName mirror the generated contacts.contact_name and
// contacts.signing_name columns (backend/src/schema.ts). Change both together.

function collapseWhitespace(value: string): string {
    return value.replace(/\s+/g, ' ').trim();
}

/** "Last, First Middle" */
export function getContactName(names: {
    firstName: string;
    middleName?: string | null;
    lastName: string;
}): string {
    const { firstName, middleName, lastName } = names;
    return collapseWhitespace(`${lastName.trim()}, ${firstName} ${middleName ?? ''}`);
}

/** "First Middle Last" */
export function getSigningName(names: {
    firstName: string;
    middleName?: string | null;
    lastName: string;
}): string {
    const { firstName, middleName, lastName } = names;
    return collapseWhitespace(`${firstName} ${middleName ?? ''} ${lastName}`);
}

export function formatAllClientNames(
    contacts: Array<{
        firstName: string;
        middleName?: string | null;
        lastName: string;
    }>,
): string {
    return contacts
        .map((contact) =>
            getSigningName({
                firstName: contact.firstName,
                middleName: contact.middleName,
                lastName: contact.lastName,
            }).trim(),
        )
        .filter((name) => name.length > 0)
        .join(', ');
}
